<template>
    <v-footer
            class="py-10 site-footer"
            dark
            color="#555"
    >
        <v-container>
            <v-row>
                <v-col cols="12" sm="2">
                    <div>
                        <router-link to="/team">{{ $t('footer.team') }}</router-link>
                    </div>
                    <div>
                        <router-link to="/press">{{ $t('footer.press') }}</router-link>
                    </div>
                    <div>
                        <router-link to="/contact">{{ $t('footer.contact') }}</router-link>
                    </div>
                    <div><a href="https://twitter.com/unsub_org" target="_blank">{{ $t('footer.twitter') }}</a></div>
                    <div><a href="https://github.com/ourresearch/get-unsub" target="_blank">{{ $t('footer.sourceCode') }}</a></div>
                </v-col>
                <v-col cols="12" sm="2">
                    <div><a :href="$docsUrl()" target="_blank">{{ $t('nav.support') }}</a></div>
                    <div>
                        <a href="https://www.youtube.com/watch?v=dztEHqbmt58" target="_blank">{{ $t('footer.watchVideo') }}</a>
                    </div>
                    <div><a href="/case-studies">{{ $t('footer.caseStudies') }}</a></div>
                    <div>
                        <router-link to="/purchase">{{ $t('footer.purchase') }}</router-link>
                    </div>
                    <div>
                        <router-link to="/login">{{ $t('footer.logIn') }}</router-link>
                    </div>
                    <div>
                        <router-link to="/unsub-toc.pdf" target="_blank">{{ $t('footer.termsOfUse') }}</router-link>
                    </div>
                    <div>
                        <router-link to="/privacy">{{ $t('footer.privacyPolicy') }}</router-link>
                    </div>

                </v-col>
                <v-col cols="12" sm="4" class="text-center">
                    <router-link to="/">
                        <img class="site-footer-logo" src="../assets/unsub-logo-white.png" alt=""/>
                    </router-link>
                </v-col>
                <v-col cols="12" sm="4" class="body-2">
                    {{ $t('footer.madeWith') }} <a style="text-decoration: underline;" href="https://ourresearch.org">OurResearch,</a> {{ $t('footer.withSupport') }} <a style="text-decoration: underline;"
                                                                href="https://www.arcadiafund.org.uk/">Arcadia</a>.
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
    export default {
        name: "SiteFooter"
    }
</script>

<style scoped lang="scss">
    .site-footer {
        line-height: 1.8;
        a {
            text-decoration: none;
            color: #fff;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    img.site-footer-logo {
        width: 100px;

    }

</style>
